export function findNode(content, nodeId) {
    if (!nodeId) {
        return null;
    }
    return content.nodes.find((node) => node.id === nodeId) ?? null;
}
export function resolveStartNodeId(content) {
    if (content.startNodeId) {
        return content.startNodeId;
    }
    return content.nodes.length > 0 ? content.nodes[0].id : null;
}
//# sourceMappingURL=scenario.js.map